import { AssetLibrary } from "../assets";
import type { EmblemLook } from "./looks";

/**
 * The flag emblems' art (FINISH_PLAN WP8, painted in WP12): each launch emblem is a painted shield in the stock crest's
 * language — the same gold-rimmed heater shield and ink as art/interface/brand/emblem_256.png, its own field and
 * charge (sources: tools/art/emblems/*.svg, rendered with tools/art/brand_render.mjs). The pennant (flagEmblem.ts) and
 * the picker draw the file over the emblem's cloth colour exactly as they draw the stock crest over the team colour.
 */
export const EMBLEM_ART_PX = 256;

/** The painted emblem for a glyph id ("ashen", "crown"), resolved through the asset library (single-file builds inline it). */
export function emblemArtUrl(glyph: EmblemLook["glyph"] | string): string {
  return AssetLibrary.resolveInlined(`./interface/emblems/${glyph}_${EMBLEM_ART_PX}.png`);
}
